import type { IconSvgObject } from './types';

const Knife02Icon: IconSvgObject = [
  ["path", { d: "M2.55092 21.4375C3.36809 22.3552 4.77419 22.0742 5.57413 21.1414L9.80205 16.2993C10.1806 15.8658 10.8462 15.8405 11.2565 16.2441L13.0417 18L20.4037 10.3469C22.6874 7.973 22.4868 4.18447 20.0199 2L2.55103 18.6798C1.79742 19.4471 1.83551 20.6342 2.55092 21.4375Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Knife02Icon;
